const aws = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:e981be43-6fe7-44f1-a226-ff59962d1998',
  userPoolId: 'eu-west-1_ZPGnhlKyx',
  userPoolClientId: '5e1brq8asgbr8jv493nah3c5d2',
  productionManagementAppsyncEndpoint: 'https://6a66oh3ufvbylg4q5ycu6xpueu.appsync-api.eu-west-1.amazonaws.com/graphql',
};
export default aws;
